import * as React from 'react';
import { useQuery } from '@apollo/react-hooks';
import { translationsQuery } from '@narvar/nth-hook-translations';
import CustomComponentContext from '../CustomComponentContext';
import {
  RetailerTranslations,
  Query,
  QueryRetailerTranslationsArgs,
  Language,
  Country,
} from '../../../__generated__/loma';

interface TempTranslationsProps {
  translationKeys: (keyof RetailerTranslations)[];
}

const useTempTranslations = ({
  translationKeys,
}: TempTranslationsProps): RetailerTranslations | null => {
  const { state } = React.useContext(CustomComponentContext);

  const {
    retailerMoniker,
    localeLanguage,
    localeCountry,
    versionName,
    type,
    category,
    trackingStatus,
  } = state.pageContext;

  const stringifiedKeys = translationKeys.join('\n');

  const { data: { retailerTranslations = {} } = {} } = useQuery<
    Pick<Query, 'retailerTranslations'>,
    QueryRetailerTranslationsArgs
  >(translationsQuery(stringifiedKeys), {
    variables: {
      // this is hardcoded in nth-hook-translations context, but not the query
      product: 'narvarjs_translations',
      retailerMoniker,
      // NOTE: this is typically bad, but there are several checks to ensure that these
      // locale params are of the correct type before they make it into page context
      // and then to britney, so it is fine for this temporary workaround.
      localeLanguage: (localeLanguage as Language) || 'en',
      localeCountry: localeCountry as Country,
      versionName,
      type,
      category,
      status: trackingStatus,
    },
  });
  return retailerTranslations;
};

export default useTempTranslations;
